module.exports = __webpack_public_path__ + "img/Wiederschaukeln.33d77cdb.jpg";